import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';
import baseDefaults from '../Base/Base.defaults';
import baseTextDefaults from '../BaseText/BaseText.defaults';
export default {
  ...cloneDeep(baseDefaults),
  size: {
    desktop: 45,
  },
  items: [
    {
      title: 'Image',
      src: 'https://res.cloudinary.com/ditbeukyz/image/upload/v1605878200/Resources/placeholder.svg?cratio=16x9',
      id: 'random',
    },
  ],
  total: '240+',
  borderColor: 'var(--color-primary)',
  totalColor: 'var(--color-primary)',
  totalTextColor: '#fff',
  description: merge(
    {...baseTextDefaults},
    {
      text: `<p><strong>James Smith, Jennifer Brown and 17 others</strong></p><p>are already enjoying more freedom. <a href="/" rel="noopener noreferrer nofollow">Read more </a></p>`,
    },
  ),
};
